require("./bootstrap");
window.Vue = require("vue");
import vuetify from "./plugins/vuetify"; // path to vuetify export

import Vuetify from "vuetify/lib";
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
    config: { id: "G-Y6EH70S8L" },
    bootstrap: false
});

import commonPage from "./commonPage";
import VueSidebarMenu from "vue-sidebar-menu";
Vue.use(VueSidebarMenu);
Vue.mixin(commonPage);

import router from "./routerPage";
import store from "./storePage";

//Vue.use(VueI18n);

Vue.use(Vuetify, { iconfont: "md" });

Vue.component("mainpage-vue", require("./components/mainPage.vue").default);

const app = new Vue({ vuetify, el: "#app", router, store });
